import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Home.css';
import heroImage from '../assets/backgrond.jpeg'; // Ensure this file exists in assets
import mensFashion from '../assets/mens_fashion.jpeg';
import womensFashion from '../assets/womens_fashion.jpeg';
import accessories from '../assets/Accessories.jpeg';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        <img src={heroImage} alt="Shop Now" className="hero-image" />
        <div className="hero-text">
          <h1>Welcome to Our Clothing Store</h1>
          <p>Find the best fashion deals at unbeatable prices!</p>
          <button className="shop-now-btn" onClick={() => navigate('/products')}>
            Shop Now
          </button>
        </div>
      </div>

      

      {/* Category Section */}
      <div className="categories">
        <div className="category-card">
          <img src={mensFashion} alt="Men's Fashion" />
          <h3>Men's Fashion</h3>
        </div>
        <div className="category-card">
          <img src={womensFashion} alt="Women's Fashion" />
          <h3>Women's Fashion</h3>
        </div>
        <div className="category-card">
          <img src={accessories} alt="Accessories" />
          <h3>Accessories</h3>
        </div>
      </div>

      {/* Contact Us Section */}
      <div className="contact-section">
        <h2>Contact Us</h2>
        <form className="contact-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" required></textarea>
          <button className="submit-btn" type="submit">Send Message</button>
        </form>
      </div>
    </div>
  );
};

export default Home;
